module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_NB-ef639f6e572c0d14d2e29d3d566a8c21.svg";